import Vue from 'vue'

function isArray(value) {
    return Object.prototype.toString.call(value) === '[object Array]';
}
function isObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
function deepClone(source) {
    let target = null;
    if (!isArray(source) && !isObject(source)) {
        target = source;
    }
    if (isArray(source)) {
        target = [];
        for (let i = 0; i < source.length; i++) {
            target[i] = deepClone(source[i]);
        }
    }
    if (isObject(source)) {
        target = {};
        for (let key in source) {
            target[key] = deepClone(source[key]);
        }
    }
    return target;
}

Vue.prototype.$deepClone = deepClone